import { memo, ReactElement, ReactNode } from "react";
import { View, ViewProps } from "react-native";

import NestedFlatNode from "./NestedFlatNode";
import { NestedNode } from "./types";

export type NestedFlatListProps<T extends NestedNode> = ViewProps & {
  data: T[];
  renderNode: (node: T, depth: number) => ReactNode;
  renderChildrenContainer?: (node: T, children: ReactNode) => ReactNode;
  renderEmptyComponent?: (depth: number) => JSX.Element;
};

function NestedFlatList<T extends NestedNode>(
  props: NestedFlatListProps<T>
): ReactElement<NestedFlatListProps<T>> {
  const { data, renderEmptyComponent, renderChildrenContainer, renderNode, ...viewProps } = props;

  return (
    <View {...viewProps}>
      {data.map((item, index) => (
        <NestedFlatNode
          key={index}
          depth={0}
          node={item}
          renderNode={renderNode}
          renderEmptyComponent={renderEmptyComponent}
          renderChildrenContainer={renderChildrenContainer}
          listKey={`root.${index}`}
        />
      ))}
    </View>
  );
}

export default memo(NestedFlatList) as typeof NestedFlatList;
